import React, { useState } from 'react'

import { getQueryParams } from '../../../packages/kiti/utils/helpers/url'
import useRouteParam from '../../../utils/routes/helpers/useParam'

const Context = React.createContext()
const { Provider } = Context

export const useCheckinState = () => React.useContext(Context) || {}
export const useCheckinQueryString = () => useCheckinState()?.queryString
export const useCheckinHandlerResult = () => useCheckinState()?.handlerResult
export const useCheckinService = () => useCheckinState()?.service

const CheckinServiceContext = ({ children }) => {
  const handlerResult = useState('loading')
  const service = useRouteParam('service')

  const queryString = getQueryParams()

  return (
    <Provider
      value={{
        service,
        queryString,
        handlerResult
      }}
    >
      {children}
    </Provider>
  )
}

export default CheckinServiceContext
